import { Loop } from "@mui/icons-material";
import { Card, CircularProgress, IconButton, Tooltip } from "@mui/material";
import { StyledCard } from "../../styled/card";

const FullWidthCardDashboard = ({
    component: ComponentDashboard,
    text,
    fetchData,
    isFetching,
    didInvalidate,
    chartHeight = 260,
}) => {
    return (
        <Card
            sx={{
                borderRadius: "6px",
                flex: 1,
                boxShadow: "1px 1px 4px #808080e0",
            }}>
            <StyledCard.IconRefreshContainer didInvalidate={didInvalidate}>
                {didInvalidate && (
                    <Tooltip title="Error en la consulta">
                        <StyledCard.ErrorDiv />
                    </Tooltip>
                )}

                {isFetching ? (
                    <StyledCard.LoadingContainer>
                        <CircularProgress size={21} />
                    </StyledCard.LoadingContainer>
                ) : (
                    <IconButton
                        sx={{
                            padding: 3,
                        }}
                        onClick={fetchData}>
                        <Loop
                            sx={{
                                cursor: "pointer",
                                color: "#818181",
                                "&:hover, &:focus": {
                                    color: "#145a8c",
                                },
                                "&:active": {
                                    color: "#2c148c",
                                },
                            }}
                        />
                    </IconButton>
                )}
            </StyledCard.IconRefreshContainer>
            <StyledCard.Dashboard
                sx={{
                    height: chartHeight,
                    minHeight: chartHeight,
                    display: "flex",
                    flexDirection: "column",
                }}>
                {ComponentDashboard}
            </StyledCard.Dashboard>
            <StyledCard.CardTextContainer>{text}</StyledCard.CardTextContainer>
        </Card>
    );
};

export default FullWidthCardDashboard;
